/**
 * Copy-link control for [data-sharer] widgets (see sharer.html).
 * Social links use plain hrefs; this only handles clipboard copy + toast.
 */
function copyTextToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }
  return new Promise((resolve, reject) => {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      resolve();
    } catch (err) {
      reject(err);
    }
    document.body.removeChild(ta);
  });
}

/**
 * @param {HTMLElement} wrap — .sharer-copy-wrap
 * @param {string} message
 * @param {boolean} isError
 */
function showCopyToast(wrap, message, isError) {
  const prev = wrap.querySelector('.sharer-copy-toast');
  if (prev) {
    prev.remove();
  }

  const toast = document.createElement('span');
  toast.className = isError ? 'sharer-copy-toast sharer-copy-toast--error' : 'sharer-copy-toast';
  toast.textContent = message;
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  wrap.appendChild(toast);

  return toast;
}

function initSharer() {
  document.querySelectorAll('[data-sharer]').forEach((root) => {
    const url = root.getAttribute('data-share-url') || '';
    const copyTrigger = root.querySelector('[data-copy-link]');
    if (!copyTrigger || !url) {
      return;
    }

    const wrap = copyTrigger.closest('.sharer-copy-wrap');
    if (!wrap) {
      return;
    }

    const defaultLabel = copyTrigger.getAttribute('data-share-tip-default') || copyTrigger.getAttribute('aria-label') || 'Click to copy link';
    const copiedLabel = copyTrigger.getAttribute('data-share-tip-copied') || 'Link copied';
    const failedLabel = copyTrigger.getAttribute('data-share-tip-failed') || 'Could not copy link';

    const setCopyFeedback = (label) => {
      copyTrigger.setAttribute('aria-label', label);
      copyTrigger.setAttribute('title', label);
    };

    const resetCopyFeedback = () => {
      setCopyFeedback(defaultLabel);
    };

    const scheduleReset = () => {
      const prev = copyTrigger.dataset.sharerCopyResetTimer;
      if (prev) {
        window.clearTimeout(Number(prev));
      }
      const t = window.setTimeout(() => {
        resetCopyFeedback();
        wrap.querySelector('.sharer-copy-toast')?.remove();
        copyTrigger.removeAttribute('data-sharer-copy-reset-timer');
      }, 2500);
      copyTrigger.setAttribute('data-sharer-copy-reset-timer', String(t));
    };

    copyTrigger.addEventListener('click', (e) => {
      e.preventDefault();

      const prev = copyTrigger.dataset.sharerCopyResetTimer;
      if (prev) {
        window.clearTimeout(Number(prev));
        copyTrigger.removeAttribute('data-sharer-copy-reset-timer');
      }
      wrap.querySelector('.sharer-copy-toast')?.remove();

      copyTextToClipboard(url)
        .then(() => {
          setCopyFeedback(copiedLabel);
          showCopyToast(wrap, copiedLabel, false);
          scheduleReset();
        })
        .catch(() => {
          setCopyFeedback(failedLabel);
          showCopyToast(wrap, failedLabel, true);
          scheduleReset();
        });
    });
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSharer);
  } else {
    initSharer();
  }
}
